import React, { Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Step4_CalendarRoute, Step5_CalendarSuccessRoute, Step6_ScheduleInterviewRoute, VacancyEditorRoute, RecruiterWorkspaceRoute, VacantePublicViewRoute, VacancyDashboardRoute, RecruiterHomeRoute, GoogleAuthCallbackRoute, CheckoutRoute, VacancyQuestionsReviewRoute, RecruiterSettingsRoute, VacancyMetricsRoute, PendingApprovalRoute } from './RouteWrappers';
import { ProtectedRoute } from './ProtectedRoute';
import { RecruiterLayout } from '../views-react/recruiter/RecruiterLayout';
import { AdminLayoutWithNotifications } from '../views-react/admin/AdminLayout';

// Lazy load initial routes
const HomeRoute = React.lazy(() => import('./HomeRoute').then(m => ({ default: m.HomeRoute })));
const AdminDashboard = React.lazy(() => import('../views-react/admin/AdminDashboard').then(m => ({ default: m.AdminDashboard })));
const AdminUsers = React.lazy(() => import('../views-react/admin/AdminUsers').then(m => ({ default: m.AdminUsers })));
const AdminConfig = React.lazy(() => import('../views-react/admin/AdminConfig').then(m => ({ default: m.AdminConfig })));
const AdminAudit = React.lazy(() => import('../views-react/admin/AdminAudit').then(m => ({ default: m.AdminAudit })));
const AdminAIMonitoring = React.lazy(() => import('../views-react/admin/AdminAIMonitoring').then(m => ({ default: m.AdminAIMonitoring })));

const LoadingFallback = () => React.createElement('div', { className: 'auth-loading-content', style: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
  React.createElement('div', { className: 'spinner-container' }, React.createElement('div', { className: 'spinner' }))
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(HomeRoute)),
  },
  {
    path: '/home',
    element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(HomeRoute)),
  },
  {
    path: '/auth/google/callback',
    element: React.createElement(GoogleAuthCallbackRoute),
  },
  {
    path: '/calendar/:jobId',
    element: React.createElement(ProtectedRoute, {
      requiresAuth: true,
      requiredRole: 'candidato',
      children: React.createElement(Step4_CalendarRoute)
    }),
  },
  {
    path: '/calendar-success/:jobId?',
    element: React.createElement(ProtectedRoute, {
      requiresAuth: true,
      requiredRole: 'candidato',
      children: React.createElement(Step5_CalendarSuccessRoute)
    }),
  },
  {
    path: '/schedule/:jobId',
    element: React.createElement(ProtectedRoute, {
      requiresAuth: true,
      requiredRole: 'candidato',
      children: React.createElement(Step6_ScheduleInterviewRoute)
    }),
  },
  {
    path: '/recruiter',
    element: React.createElement(ProtectedRoute, {
      requiresAuth: true,
      requiredRole: 'reclutador',
      children: React.createElement(RecruiterLayout)
    }),
    children: [
      { index: true, element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(VacancyDashboardRoute)) },
      { path: 'new', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(RecruiterHomeRoute)) },
      { path: 'vacancies/:id/edit', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(VacancyEditorRoute)) },
      { path: 'workspace/:vacanteId?', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(RecruiterWorkspaceRoute)) },
      { path: 'metrics/:vacanteId', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(VacancyMetricsRoute)) },
      { path: 'vacancies/:id/questions', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(VacancyQuestionsReviewRoute)) },
      { path: 'checkout', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(CheckoutRoute)) },
      { path: 'settings', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(RecruiterSettingsRoute)) },
    ],
  },
  {
    path: '/admin',
    element: React.createElement(ProtectedRoute, {
      requiresAuth: true,
      requiredRole: 'admin',
      children: React.createElement(AdminLayoutWithNotifications),
    }),
    children: [
      { index: true, element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(AdminDashboard)) },
      { path: 'users', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(AdminUsers)) },
      { path: 'config', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(AdminConfig)) },
      { path: 'audit', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(AdminAudit)) },
      { path: 'ai-monitoring', element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(AdminAIMonitoring)) },
    ],
  },
  {
    path: '/pendiente',
    element: React.createElement(Suspense, { fallback: React.createElement(LoadingFallback) }, React.createElement(PendingApprovalRoute)),
  },
  {
    path: '/vacante/:id',
    element: React.createElement(VacantePublicViewRoute),
  },
  {
    path: '/vacancy/:id',
    element: React.createElement(VacantePublicViewRoute),
  },
]);
